export function getClassNames(event) {
	switch (event) {
		case 'attribute:videoPosition':
			return ['media-normal', 'media-left', 'media-right', 'media-full'];
		case 'attribute:videoSize':
			return [
				'media-auto-size',
				'media-small',
				'media-medium',
				'media-large',
			];
	}
	return null;
}
